import {
  ApplicationConfig,
  LOCALE_ID,
  provideBrowserGlobalErrorListeners,
} from '@angular/core';
import { provideRouter, withViewTransitions } from '@angular/router';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import {
  MsalBroadcastService,
  MsalGuard,
  MsalInterceptor,
  MsalService,
} from '@azure/msal-angular';
import {
  MSAL_PROVIDERS,
} from './auth/msal-auth.config';
import { PublicChatMsalSkipInterceptor } from './auth/public-chat-msal-skip.interceptor';
import { routes } from './app.routes';
import { provideToastr } from 'ngx-toastr';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideToastr(),
    provideRouter(routes, withViewTransitions()),
    provideHttpClient(withInterceptorsFromDi()),
    ...MSAL_PROVIDERS,
    MsalService,
    MsalGuard,
    MsalBroadcastService,
    MsalInterceptor,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: PublicChatMsalSkipInterceptor,
      multi: true,
    },
    {
      provide: LOCALE_ID,
      useValue: 'es-ES'
    }
  ],
};
